<template>
  <div>
    <el-dialog
      :visible.sync="innerVisible"
      :title="$t('Warehouse.BatchMaintenance')"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form class="spacing">
        <el-radio-group v-model="maintenanceType" @change="onMaintenanceTypeChanged">
          <el-radio label="all">{{ $t('Warehouse.maintenanceAllType') }}</el-radio>
          <el-radio label="containerNo">{{ $t('Warehouse.maintenanceContainerNoType') }}</el-radio>
          <el-radio label="weightAndSize">{{ $t('Warehouse.maintenanceWeightAndSizeType') }}</el-radio>
        </el-radio-group>
      </el-form>
      <el-form label-width="120px" label-position="right">
        <el-row>
          <el-col :span="8">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('Warehouse.boxNum') }}</span>
              <el-input v-model="fillData.boxesNumber" :no="'boxesNumber'" style="width: 200px" @input="onInputBoxNumber" />
            </el-form-item>
          </el-col>
          <el-col v-if="maintenanceAllOrNoType" :span="16">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('Warehouse.boxSeq') }}</span>
              <el-select v-model="fillData.boxSeqLen" :style="{width: $selectByLang('80px', '80px', '80px', '120px', '100px', '100px'), marginRight: '8px'}">
                <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input v-model="fillData.startSeq" :no="'startSeq'" style="width: 50px;margin-right: 8px" @input="onInputStartSeq" />
              <span style="font-family: 'Open Sans', Arial, sans-serif">——</span>
              <el-input v-model="fillData.endSeq" :no="'endSeq'" disabled style="width: 50px;margin-left: 8px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="maintenanceAllOrNoType">
          <el-col :span="8">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('Warehouse.PerContainerNo') }}</span>
              <el-input v-model="fillData.shipmentId" :no="'shipmentId'" style="width: 200px" />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="PO Number:">
              <el-input v-model="fillData.poNumber" :no="'poNumber'" style="width: 228px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="maintenanceAllOrSizeType">
          <el-col :span="8">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_ChineseCargoName') + ':' }}</span>
              <el-input v-model="fillData.cargoChineseName" :no="'cargoChineseName'" style="width: 200px" />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_EnglishCargoName') + ':' }}</span>
              <el-input v-model="fillData.cargoEnglishName" :no="'cargoEnglishName'" style="width: 228px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="maintenanceAllOrSizeType">
          <el-col :span="8">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('Warehouse.DialogSingleBoxWeight')+':' }}</span>
              <el-input v-model="fillData.singleBoxWeight" :no="'singleBoxWeight'" style="width: 200px" />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('Warehouse.BoxSize')+':' }}</span>
              <el-input v-model="fillData.boxLength" :placeholder="$t('Warehouse.boxLengthPlaceholder')" :no="'boxLength'" style="width: 68px" />
              <el-input v-model="fillData.boxWidth" :placeholder="$t('Warehouse.boxWidthPlaceholder')" :no="'boxWidth'" style="width: 68px" />
              <el-input v-model="fillData.boxHeight" :placeholder="$t('Warehouse.BoxHeightPlaceholder')" :no="'BoxHeight'" style="width: 68px;margin-right: 8px" />
              <span style="font-family: 'Open Sans', Arial, sans-serif">CM</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form class="spacing">
        <el-button type="primary" @click="fillDataHandler">{{ $t('Warehouse.FillData') }}</el-button>
        <el-button type="danger" @click="clearDataHandler">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
        <el-button type="danger" @click="delDetailHandler">{{ $t('Warehouse.DeleteCargo') }}</el-button>
      </el-form>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          ref="maintenanceAllTypeTable"
          config-module="9300015"
          :grid-options="gridOptions"
          :column-defs="maintenanceAllTypeColumn"
          :row-data="detailList"
          style="min-height: 350px"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <span slot="footer">
        <el-button type="primary" :no="'save'" @click="saveCallBack">{{ $t('common.btn.save') }}</el-button>
        <el-button :no="'cancel'" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 货箱编号编辑弹窗 -->
    <container-no-editor
      v-if="containerNoEditor.visible"
      :visible.sync="containerNoEditor.visible"
      :shipment-id="containerNoEditor.shipmentId"
      :warehouse-in-detail-list="detailList"
      @detailSaveCallBack="containerNoEditor.detailSaveCallBack"
      @close="containerNoEditor.visible=false"
    />
  </div>
</template>

<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import { FbaWarehouseInDetail } from '@/class/model/booking/FbaWarehouseInDetail'
import { getGridSelected } from '@/utils/agGrid'
import StrUtils from '@/utils/StrUtils'
import ContainerNoEditor from '@/views/cargo/v0/FBA/ContainerNoEditor'

export default {
  name: 'BatchMaintenanceDialog',
  components: { ContainerNoEditor },
  props: {
    visible: { type: Boolean, required: true },
    jobKey: { type: String, default: '' },
    existDetailList: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      maintenanceType: 'all',
      gridApi: null,
      // 1 - 3位长度
      // 2 - 6位长度
      types: [],
      detailList: [],
      baseFillData: {
        boxesNumber: '',
        boxSeqLen: 6,
        startSeq: '',
        endSeq: '',
        shipmentId: '',
        poNumber: '',
        singleBoxWeight: '',
        boxLength: '',
        boxWidth: '',
        boxHeight: '',
        cargoChineseName: '',
        cargoEnglishName: ''
      },
      fillData: {
        boxesNumber: '',
        boxSeqLen: 6,
        startSeq: '',
        endSeq: '',
        shipmentId: '',
        poNumber: '',
        singleBoxWeight: '',
        boxLength: '',
        boxWidth: '',
        boxHeight: '',
        cargoChineseName: '',
        cargoEnglishName: ''
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        selectedRowIndex: -1,
        singleClickEdit: true,
        onCellFocused: event => {
          this.gridOptions.selectedRowIndex = event.rowIndex
          this.onContainerNoCellFocused(event)
        },
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridColumnEditGroup
        }
      },
      containerNoEditor: {
        visible: false,
        key: '',
        shipmentId: '',
        detailSaveCallBack: (result) => {
          const { containerNo } = result
          const goodsDetailList = []
          this.detailList.forEach(goodsDetail => {
            if (goodsDetail.tmpUuid === this.containerNoEditor.key) {
              goodsDetail.containerNo = containerNo
            }
            goodsDetailList.push(goodsDetail)
          })
          this.detailList = goodsDetailList
        }
      },
      maintenanceAllTypeColumn: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true,
          pinned: 'left'
        },
        {
          headerName: this.$t('Warehouse.ContainerNo'),
          headerClass: 'blueStyle',
          field: 'containerNo', colId: 'containerNo', minWidth: 150
        }, {
          headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150,
          headerClass: 'blueStyle',
          editable: () => this.shipmentIdEditable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: (params) => {
            this.onShipmentIdChange(params)
          }
        }, {
          headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150
        }, {
          headerName: this.$t('Warehouse.SingleBoxWeight'),
          headerClass: 'blueStyle',
          field: 'singleBoxWeight',
          colId: 'singleBoxWeight',
          minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        }, {
          headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
          headerClass: 'blueStyle',
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        }, {
          headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
          headerClass: 'blueStyle',
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        }, {
          headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
          headerClass: 'blueStyle',
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
          headerClass: 'blueStyle',
          field: 'cargoEnglishName',
          colId: 'cargoEnglishName',
          minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
          headerClass: 'blueStyle',
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        }, {
          headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0')
          }
        }, {
          headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.MaterialQuality'),
          field: 'materialQuality',
          colId: 'materialQuality',
          minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        }, {
          headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        }, {
          headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('FbaJob.ElectricCol'), field: 'electric', colId: 'electric', minWidth: 150,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                code: true,
                value: this.$t('SeaExport.Yes')
              }]
            }
          }
        }, {
          headerName: this.$t('FbaJob.MagneticCol'), field: 'magnetic', colId: 'magnetic', minWidth: 150,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                code: true,
                value: this.$t('SeaExport.Yes')
              }]
            }
          }
        }, {
          headerName: this.$t('FbaJob.PowderyCol'), field: 'powdery', colId: 'powdery', minWidth: 150,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                code: true,
                value: this.$t('SeaExport.Yes')
              }]
            }
          }
        }, {
          headerName: this.$t('FbaJob.LiquidCol'), field: 'liquid', colId: 'liquid', minWidth: 150,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                code: true,
                value: this.$t('SeaExport.Yes')
              }]
            }
          }
        }, {
          headerName: this.$t('Warehouse.ProductDescription'),
          field: 'productDescription',
          colId: 'productDescription',
          minWidth: 150,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }
      ]
    }
  },
  computed: {
    maintenanceAllOrNoType() {
      return this.maintenanceType === 'all' || this.maintenanceType === 'containerNo'
    },
    maintenanceAllOrSizeType() {
      return this.maintenanceType === 'all' || this.maintenanceType === 'weightAndSize'
    },
    shipmentIdEditable() {
      return this.maintenanceType === 'weightAndSize'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    init() {
      this.types.push({ label: this.$t('Warehouse.boxSeqType3'), value: 3 })
      this.types.push({ label: this.$t('Warehouse.boxSeqType6'), value: 6 })
    },
    calEndSeq() {
      const endSeq = Number(this.fillData.startSeq) + Number(this.fillData.boxesNumber) - 1
      this.fillData.endSeq = endSeq < 0 ? '' : endSeq
    },
    onInputStartSeq() {
      this.calEndSeq()
    },
    onInputBoxNumber() {
      this.calEndSeq()
    },
    fillDataHandler() {
      if (!this.checkFillData()) {
        return
      }
      for (let i = this.fillData.startSeq; i <= this.fillData.endSeq; i++) {
        const detail = new FbaWarehouseInDetail().fillDefaultValue().getData()
        detail.boxesNumber = 1
        detail.tmpUuid = Math.random().toString(36).slice(3)
        detail.updated = true
        detail.jobUuid = this.jobKey
        detail.cargoChineseName = this.fillData.cargoChineseName
        detail.cargoEnglishName = this.fillData.cargoEnglishName
        // 填充所有信息或仅货箱号数据
        if (this.maintenanceAllOrNoType) {
          const startSeqFmt = i.toString().padStart(this.fillData.boxSeqLen, '0')
          detail.containerNo = this.fillData.shipmentId + startSeqFmt
          detail.shipmentId = this.fillData.shipmentId
          detail.poNumber = this.fillData.poNumber
        }
        // 填充所有信息或仅商品信息数据
        if (this.maintenanceAllOrSizeType) {
          detail.singleBoxWeight = Number(this.fillData.singleBoxWeight)
          detail.boxLength = Number(this.fillData.boxLength)
          detail.boxWidth = Number(this.fillData.boxWidth)
          detail.boxHeight = Number(this.fillData.boxHeight)
          detail.weight = detail.singleBoxWeight * detail.boxesNumber
        }
        this.detailList.push(detail)
      }
    },
    checkFillData() {
      if (!this.fillData.boxesNumber) {
        this.$message.warning(this.$t('Warehouse.boxesNumberNotNull'))
        return false
      }
      // 填充所有信息或仅货箱号数据前校验
      if (this.maintenanceAllOrNoType) {
        if (!this.fillData.startSeq) {
          this.$message.warning(this.$t('Warehouse.boxSeqNotNull'))
          return false
        }
        if (!this.fillData.shipmentId) {
          this.$message.warning(this.$t('Warehouse.shipmentIdNotNull'))
          return false
        }
      }
      // 填充所有信息或仅商品信息数据校验
      if (this.maintenanceAllOrSizeType) {
        if (!this.fillData.singleBoxWeight) {
          this.$message.warning(this.$t('Warehouse.singleBoxWeightNotNull'))
          return false
        }
        if (!this.fillData.boxLength || !this.fillData.boxWidth || !this.fillData.boxHeight) {
          this.$message.warning(this.$t('Warehouse.boxesSizeNotNull'))
          return false
        }
        if (!this.fillData.cargoChineseName) {
          this.$message.warning(this.$t('Warehouse.cargoChineseNameNotNull'))
          return false
        }
        if (!this.fillData.cargoEnglishName) {
          this.$message.warning(this.$t('Warehouse.cargoEnglishNameNotNull'))
          return false
        }
      }
      return true
    },
    clearDataHandler() {
      this.$confirm(this.$t('Warehouse.deleteTheDetailRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'warning'
      }).then(() => {
        Object.assign(this.fillData, this.baseFillData)
        this.detailList = []
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    delDetailHandler() {
      this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        getGridSelected(this.gridOptions).forEach(rowData => {
          const index = this.detailList.findIndex(item => item.tmpUuid === rowData.tmpUuid)
          if (index > -1) {
            this.detailList.splice(index, 1)
          }
        })
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    onMaintenanceTypeChanged() {
      Object.assign(this.fillData, this.baseFillData)
    },
    saveCallBack() {
      if (!this.saveCheck()) {
        return
      }
      this.$emit('saveCallBack', this.detailList)
      this.$emit('close')
    },
    saveCheck() {
      if (Number(this.fillData.boxSeqLen) === 3) {
        if (Number(this.fillData.endSeq) > 999) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.boxSeqTooLong', 999)))
          return false
        }
      } else if (Number(this.fillData.boxSeqLen) === 6) {
        if (Number(this.fillData.endSeq) > 999999) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.boxSeqTooLong', 999999)))
          return false
        }
      }
      for (const detail of this.detailList) {
        for (const existDetail of this.existDetailList) {
          if (existDetail.containerNo === detail.containerNo) {
            this.$message.warning(StrUtils.substitute(this.$t('Warehouse.duplicateContainerNo'), detail.containerNo))
            return false
          }
        }
      }
      return true
    },
    onContainerNoCellFocused(event) {
      if (event.column && event.column.colId === 'containerNo') {
        const data = this.gridOptions.api.getDisplayedRowAtIndex(event.rowIndex).data
        if (data !== null) {
          if (!this.allowContainerNoCellEdit(data)) {
            return
          }
          this.containerNoEditor.shipmentId = data.shipmentId
          this.containerNoEditor.visible = true
          this.containerNoEditor.key = data.tmpUuid
        }
      }
    },
    allowContainerNoCellEdit(data) {
      if (!data.shipmentId) {
        this.$message.warning(this.$t('Warehouse.shipmentIdNotNull'))
        return false
      }
      return true
    },
    async onShipmentIdChange(params) {
      const goods = params.data
      const containerNo = goods.containerNo
      if (containerNo) {
        const internal = this.gridOptions.api.getSelectedRows()
        await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          const newContainerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
          // 校验containerNo是否重复
          if (this.containerNoDuplicate(newContainerNo)) {
            goods.shipmentId = params.oldValue
            this.gridOptions.api.updateRowData({ update: internal })
            return
          }
          goods.containerNo = newContainerNo
          this.gridOptions.api.updateRowData({ update: internal })
        }).catch(() => {
          goods.shipmentId = params.oldValue
          this.gridOptions.api.updateRowData({ update: internal })
          return Promise.reject(this.$t('Message.EditCancelled'))
        })
      }
    },
    onCellChange(params) {
      const field = params.colDef.field
      const goods = params.data
      const internal = this.detailList.goodGridOptions.api.getSelectedRows()
      // 编辑单货箱重量同步重量
      if (field === 'singleBoxWeight') {
        goods.weight = goods.singleBoxWeight * goods.boxesNumber
        this.detailList.goodGridOptions.api.updateRowData({ update: internal })
      }
    },
    // 验证containerNo是否重复
    containerNoDuplicate(containerNo) {
      // 校验维护弹窗内的
      for (const detail of this.detailList) {
        if (containerNo === detail.containerNo) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.duplicateContainerNo'), containerNo))
          return true
        }
      }
      // 校验已维护的
      for (const detail of this.existDetailList) {
        if (containerNo === detail.containerNo) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.duplicateContainerNo'), containerNo))
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
.blueStyle {
  color: $--color-primary-light-1;
}
</style>
